export default "__VITE_ASSET__BYMNX2Jo__"